import { CarousalC } from "Common/Carousel/index.tsx";
import { FormC } from "Common/Form/index.tsx";
import InputC from "Common/Inputs/index.tsx";
import { RelationSelect } from "components/HeadlessCMS/functions";
import { SVG } from "components/HeadlessCMS/svg";
import Nodatacomponent from "components/Nodatacomponent";
import { useEffect } from "react";
import { toast } from "react-toastify";

const formatData = (item, index) => {
    return {
      src: item.thumbnailPath || item.filePath,
      altText: item.fileOriginalName,
      caption: item.caption || '',
      filePath: item.filePath,
      id: item.mediaFileId, // Assuming the key should be a unique identifier
    };
  };

const SideOverlay = ({ drawerOpen, setDrawerOpen, Inputvalues, SelectedType, getArrayComponrnt, getComponrnt, setOverlaySelectedType, togglemodel, loadRelationOptions, Components, UpdateRelationInputvalues }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setDrawerOpen(false);
                setOverlaySelectedType(null);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (

        <>
            <div
                className={`${drawerOpen ? 'cart-sidebar-open cart-sidebar-open-v2' : 'cart-sidebar-close'
                    } ${false && 'pb-0'} p-4 responsovivecart-2 `}
                style={{ width: "auto" }}
            >
                <img
                    alt="cross"
                    className="float-end cursor-pointer m-2 cross-icon-cart"
                    height="30px"
                    width="30px"
                    onClick={() => {
                        setOverlaySelectedType(null)
                        setDrawerOpen(false);
                    }}
                    src="/manage/images/SVG/close2.svg"
                ></img>



                {/* <FormC className="h-100" title={SelectedType?.data?.label}> */}
                {SelectedType ? (
                    <>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4 className="main-title">{SelectedType?.data?.label}</h4>
                                {/* <span className="Title-small">Build the data architecture of your content</span> */}
                            </div>
                        </div>
                        <div className="Structurebox h-100" style={{ overflowY: "unset" }} >
                            {SelectedType.keys.length > 0 ? (
                                <>
                                    <div className="row">
                                        {SelectedType.keys.map((item, index) => {
                                            var resultArray = []
                                            if (item.type === "Component" && item.repeatable) {


                                                const data = Components.filter((datakey) => item.Component === datakey.id);
                                                resultArray = Array.from({ length: Inputvalues?.[item.name]?.length }, (_, index) => index + 1);
                                            }
                                            if (item.type === "JSON") {
                                                var sample = Inputvalues[item.name]
                                            }

                                            return item.type === 'dropzone' ? (
                                                <div className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass" key={index}>
                                                    <InputC
                                                        label={item.name}
                                                    />
                                                    <div className="Dropzone" >

                                                        {
                                                            Inputvalues?.[item.name] ?
                                                                // <div className=''>
                                                                //     {/* <img src={Inputvalues[item.name][0].src} /> */}
                                                                //     <p>
                                                                //         Drag and drop file here or <span className="color-underline">Choose file</span>
                                                                //     </p>
                                                                //     <p>
                                                                //         <span> {Inputvalues[item.name].length} </span> Media File Selected <span className="color-underline"></span>
                                                                //     </p>
                                                                //     {/* <span>( {Inputvalues[item.name].length} )</span> */}
                                                                // </div>
                                                                <CarousalC click={togglemodel} item={item} items={Inputvalues?.[item?.name].map(formatData)} />
                                                                :
                                                                <div onClick={() => togglemodel(item)}>
                                                                    <div className="d-flex justify-content-center">
                                                                        {SVG.Dropzone}
                                                                    </div>
                                                                    <div className="d-flex justify-content-center dropzone-font-size">

                                                                        <p>
                                                                            Drag and drop file here or <span className="color-underline">Choose file</span>
                                                                        </p>
                                                                    </div>

                                                                </div>

                                                        }

                                                    </div>
                                                </div>
                                            ) : item.type === 'Component' ? (
                                                <div className="col-lg-12 col-md-12 col-sm-12 mt-3">


                                                    {
                                                        resultArray.length > 0 && item.repeatable ?
                                                            resultArray.map((data, index) => {
                                                                return getArrayComponrnt(item, index)
                                                            }

                                                            )
                                                            :
                                                            item.repeatable ?
                                                                getArrayComponrnt(item, 0)
                                                                :
                                                                getComponrnt(item)
                                                    }




                                                </div>
                                            ) :
                                                item.type === "JSON" ? (
                                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                                                        <InputC
                                                            isClearable={false}
                                                            label={item.name}
                                                            name={item.name}
                                                            type={"json"}
                                                            placeholder={item.name}
                                                            options={item.options}
                                                            inputvalue={sample}
                                                            required={item.required}
                                                            size="sm"
                                                            disabled={true}
                                                        />
                                                    </div>
                                                ) :
                                                    item.type === "number" ? (
                                                        <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                            <InputC
                                                                isClearable={false}
                                                                label={item.name}
                                                                name={item.name}
                                                                type={item.type === "UUID" ? "text" : item.type}
                                                                placeholder={item.name}
                                                                options={item.options}
                                                                inputvalue = {(() => {
                                                                    try {
                                                                      if (!Inputvalues || !item?.name) return undefined;
                                                                  
                                                                      const value = Inputvalues[item.name];
                                                                  
                                                                      if (item.type === 'select') {
                                                                        return value?.value ?? undefined;
                                                                      }
                                                                  
                                                                      if (item.type === 'togglemode') {
                                                                        return value ?? undefined;
                                                                      }
                                                                  
                                                                      return value ?? undefined;
                                                                    } catch (error) {
                                                                      console.error("Error accessing inputvalue:", error);
                                                                      return undefined;
                                                                    }
                                                                  })()}                                                                required={item.required}
                                                                size="sm"
                                                                // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                disabled={true}

                                                            />
                                                        </div>
                                                    ) : item.type === "text" ?
                                                        (
                                                            <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                                <InputC
                                                                    isClearable={false}
                                                                    label={item.name}
                                                                    name={item.name}
                                                                    type={item.type === "UUID" ? "text" : item.type}
                                                                    placeholder={item.name}
                                                                    options={item.options}
                                                                    inputvalue={item.type === "select" ? Inputvalues?.[item.name]?.value : item.type === "togglemode" ? Inputvalues?.[item.name] : Inputvalues?.[item.name]}
                                                                    required={item.required}
                                                                    size="sm"
                                                                    // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                    disabled={true}

                                                                />
                                                            </div>
                                                        )
                                                        : item.type === "UUID" ?
                                                            (
                                                                <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                                    <InputC
                                                                        isClearable={false}
                                                                        label={item.name}
                                                                        name={item.name}
                                                                        type={item.type === "UUID" ? "text" : item.type}
                                                                        placeholder={item.name}
                                                                        options={item.options}
                                                                        inputvalue={item.type === "select" ? Inputvalues?.[item.name]?.value : item.type === "togglemode" ? Inputvalues?.[item.name] : Inputvalues?.[item.name]}
                                                                        required={item.required}
                                                                        size="sm"
                                                                        // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                        disabled={true}

                                                                    />
                                                                </div>
                                                            )
                                                            :
                                                            item.type === "date" ?
                                                                (
                                                                    <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                                        <InputC
                                                                            isClearable={false}
                                                                            label={item.name}
                                                                            name={item.name}
                                                                            type={item.format === "Time" ? "time" : item.format === "DateTime" ? "datetime-local" : item.type}
                                                                            placeholder={item.name}
                                                                            options={item.options}
                                                                            inputvalue={item.type === "select" ? Inputvalues?.[item.name]?.value : item.type === "togglemode" ? Inputvalues?.[item.name] : Inputvalues?.[item.name]}
                                                                            required={item.required}
                                                                            size="sm"
                                                                            // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                            disabled={true}

                                                                        />
                                                                    </div>
                                                                )
                                                                :
                                                                item.type === "relation" ?
                                                                    (
                                                                        // <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                                        //     <InputC
                                                                        //         isClearable={false}
                                                                        //         label={item.name}
                                                                        //         name={item.name}
                                                                        //         type="Asyncselect"
                                                                        //         isEdit={false}
                                                                        //         placeholder={item.name}
                                                                        //         loadOptions={(e) => loadRelationOptions(e, item)}
                                                                        //         inputvalue={item.type === "select" ? Inputvalues[item.name]?.value : item.type === "togglemode" ? Inputvalues[item.name] : Inputvalues[item.name]}
                                                                        //         required={item.required}
                                                                        //         size="sm"
                                                                        //         // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                        //         change={(e) => item.type === "select" || item.type === "editor" ? handleInput(item.name, e) : item.type === "togglemode" ? handleInput(item.name, !Inputvalues[item.name]) : handleInput(item.name, e.target.value)}
                                                                        //     />
                                                                        // </div>
                                                                        <>
                                                                        </>
                                                                    )
                                                                    :
                                                                    (
                                                                        <div className={` ${item.type === "CMSeditor" ? "col-lg-12 col-md-12 col-sm-12 mt-3" : "col-lg-6 col-md-6 col-sm-12 mt-3"}`} key={index}>
                                                                            <InputC
                                                                                isClearable={false}
                                                                                label={item.name}
                                                                                name={item.name}
                                                                                type={item.type === "UUID" ? "text" : item.type}
                                                                                placeholder={item.name}
                                                                                options={item.options}
                                                                                inputvalue={item.type === "select" ? Inputvalues?.[item.name]?.value : item.type === "togglemode" ? Inputvalues?.[item.name] : Inputvalues?.[item.name]}
                                                                                required={item.required}
                                                                                size="sm"
                                                                                disabled={true}

                                                                            // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                                            // change={(e) => item.type === "select" || item.type === "editor" ? handleInput(item.name, e) : item.type === "togglemode" ? handleInput(item.name, !Inputvalues[item.name]) : handleInput(item.name, e.target.value)}
                                                                            />
                                                                        </div>
                                                                    )
                                        })}
                                    </div>

                                    <div className="row">
                                        {SelectedType?.relationShipList && SelectedType?.relationShipList.map((item, index) => {
                                            return (
                                                <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                                    <InputC
                                                        disabled={!!SelectedType}
                                                        isClearable={false}
                                                        label={item.name}
                                                        name={item.name}
                                                        type="Asyncselect"
                                                        isEdit={!RelationSelect(item.relationShipName, item.relationShipType, item.mainId !== null)}
                                                        placeholder={item.name}
                                                        loadOptions={(inputValue, callback) => loadRelationOptions(inputValue, item, callback)} // Pass a function that invokes loadRelationOptions with inputValue and callback
                                                        inputvalue={UpdateRelationInputvalues[item.name]?.ids}
                                                        required={item.required}
                                                        size="sm"
                                                    // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                                    // change={(e) => handleRelationInput(item.name, e, item)}
                                                    />
                                                </div>
                                            )

                                        })}
                                    </div>

                                </>
                            ) : (
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <div className="w-25">
                                        <Nodatacomponent text="No Structure is Found" />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                ) : (
                    <div className="h-100 d-flex justify-content-center align-items-center">
                        <div className="w-25">
                            <Nodatacomponent text="Select a type" />
                        </div>
                    </div>
                )}
                {/* </FormC> */}















            </div>
            {drawerOpen && (
                <div
                    onClick={() => {
                        setDrawerOpen(false);
                        setOverlaySelectedType(null)
                    }}
                    onke
                    className={`modal-backdrop backdropCart fade ${drawerOpen && 'show'}`}
                ></div>
            )}
        </>
    )



}


export default SideOverlay